// src/email.ts
function formatEmailAddress(email) {
  return email.trim().toLowerCase();
}

// src/delay.ts
function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

// src/random.ts
function intFromInterval(interval) {
  const [x, y] = interval;
  const max = Math.max(x, y);
  const min = Math.min(x, y);
  return Math.floor(Math.random() * (max - min + 1) + min);
}
var Random = {
  intFromInterval
};

// src/cursor.ts
function getCursor(items, key, size) {
  const item = items[items.length - 1];
  if (items.length < size || !item) {
    return void 0;
  }
  const value = item[key];
  return Buffer.from(value.toString()).toString("base64");
}
function decodeCursor(cursor) {
  if (!cursor) {
    return void 0;
  }
  return Buffer.from(cursor, "base64").toString("ascii");
}

// src/object.ts
function createObjectMap(data, key) {
  return data.reduce((acc, item) => {
    const k = item[key].toString();
    acc[k] = item;
    return acc;
  }, {});
}
export {
  Random,
  createObjectMap,
  decodeCursor,
  delay,
  formatEmailAddress,
  getCursor
};
//# sourceMappingURL=index.mjs.map